// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InteractionOutlinedSvg from "@ant-design/icons-svg/es/asn/InteractionOutlined";
import AntdIcon from '../components/AntdIcon';

var InteractionOutlined = function InteractionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InteractionOutlinedSvg
  }));
};

InteractionOutlined.displayName = 'InteractionOutlined';
export default React.forwardRef(InteractionOutlined);